import type { BariPreMdoReportData } from '@common/validation/customControls/bariPre/bariPreMdoReport/v1/bariPreMdoReportSchemaV1';
import { initialConclusieAanvullendData, initialIndicatieVoorVerwijzingData } from '../utils';

export const initialData: BariPreMdoReportData = {
    ...initialConclusieAanvullendData,
    ...initialIndicatieVoorVerwijzingData,
    advies_aan_chirurg: null,
    advies_aan_huisarts: null,
    advies_aan_patient: null,
    datum_mdo: null,
    inclusie_in_zorgpad: null,
    klaar_om_te_versturen: false,
    toelichting: null,
    verslag_bespreking_mdo: null,
    verwijsbrief_nodig: null,
};
